quoteModule.controller('vehicleDefinitionController',
    ['$scope','$rootScope', '$window', 'vehicleDefinitionService', 'quoteCreationEvents','$q','rateQuoteCoordService',
        'welcomeEvents', 'tuxFabMenuEvents', 'rateQuoteRetrievalCoordService','ListItemSetup','quoteInitializationService',
        'contractCreationService','quoteIntegrationConstants','erateSessionVarsService', 'vehicleProductsProcessingService',
        'dealerPreferencesService','TLCError','AppErrorCodes','vehicleTypeConstants','providerFeaturesService','imSessionVarsService',
        function ($scope, $rootScope, $window, vehicleDefinitionService, quoteCreationEvents, $q, rateQuoteCoordService,
                  welcomeEvents, tuxFabMenuEvents, rateQuoteRetrievalCoordService, ListItemSetup,quoteInitializationService,
                  contractCreationService, quoteIntegrationConstants, erateSessionVarsService, vehicleProductsProcessingService,
                  dealerPreferencesService, TLCError, AppErrorCodes, vehicleTypeConstants,providerFeaturesService, imSessionVarsService) {

            /*
             The vehicle controller keeps track of the year/make/model and vin "explosion" information for the quote. Anytime we change
             the vehicle attributes (date of sale, odometer, whatever), we need to signal that we should clear anything
             existing, and re-retrieve products.

             We also integrate with external pages to grab the vehicle information. Usually this consists of the VIN, date of
             sale, and odometer.

             We can also retrieve the vehicle information from an existing quote.
             */
            var self = this;
            //initialize the directive with the controller
            this.init = function(element){
                self.$element = element;
            }
            $scope.today = new Date();
            $scope.ignoreDoNotSignalVehicleChange = false;//because we closed the FAB menu before VIN data populated
            $scope.contractsProcessing = contractCreationService.contractsProcessing;
            $scope.quoteMode = null;
            $scope.menuQuoteIntegrated = quoteIntegrationConstants.menuQuoteIntegrated;
            $scope.menuContractIntegrated = quoteIntegrationConstants.menuContractIntegrated;
            $scope.providerRequiresInservice = false;

            //vehicle definition object (in scope)
            $scope.vehicleDefinition = {
                modelYearSetup: new ListItemSetup("modelyear"),
                makeSetup: new ListItemSetup("make"),
                modelSetup: new ListItemSetup("model"),
                vehicleUsageSetup: new ListItemSetup("vehicleusage"),
                vehicleCertSetup: new ListItemSetup("vehiclecert"),
                vehiclePlanTypeSetup: new ListItemSetup("plantype"),
                prevVIN: "",
                prevOdometer: "",
                prevyear: "",
                prevmakeId: "",
                prevmodelId: "",
                prevCert: "",
                prevUsage: "",
                dealInfoChanged: false,
                allowYearMakeModelQuoting : false,
                vinDecode: false,
                usageRequired: false
            };

            $scope.vehicleData = {};
            $scope.supportedVehicleType = vehicleTypeConstants.auto;
            $scope.newGUID = null;
            $scope.minDate='';
            $scope.maxDate = '';
            //Initializing the URL for eligibility, if provider doesn't verify eligibility, the link is not shown
            $scope.verifyEligibilityUrl = '';
            $scope.providerUsagesByVin = false;
            //initialization
            $scope.initializeDetails = function(){
                $scope.providerUsagesByVin = vehicleDefinitionService.providerHasUsagesByVIN();
                $scope.vehicleData = rateQuoteCoordService.VehicleData;
                getProviderVehicleMode();
                $scope.getVehicleModelYears();
                $scope.getVehicleModelYears();
                $scope.getVehicleMakes();
                $scope.getVehicleCerts();
                $scope.getVehicleSaleTypes();
                if ($scope.providerUsagesByVin) {
                    $scope.vehicleDefinition.usageRequired = false;
                    $scope.getVehicleVinUsages();
                } else {
                    $scope.getVehicleUsages();
                }
                $scope.newGUID = null;

                getProviderDateOfSaleSettings();
                getProviderInServiceDateSettings();

                $scope.quoteMode = erateSessionVarsService.getQuotingMode();
                vehicleDefinitionService.getProviderRequiresInservice()
                    .then(
                        function gotResult(res){
                            $scope.providerRequiresInservice = res;
                        }
                    );

                vehicleDefinitionService.getVerifyEligibilityUrl()
                    .then(function (url) {
                        $scope.verifyEligibilityUrl = url;
                    });

                quoteInitializationService.signalChildReady('vehicleReady');
            };


            var getProviderVehicleMode = function() {
                var defer = $q.defer();

                 vehicleDefinitionService.getProviderVehicleMode()
                     .then(function(data) {
                             $scope.vehicleDefinition.allowYearMakeModelQuoting =
                                 data.YearMakeModelMode && data.YearMakeModelMode === 'ON';

                                $scope.vehicleDefinition.vinDecode =
                                    data.VinExplodeMode &&
                                    (data.VinExplodeMode.toUpperCase() === 'VINEXPLODEREMOTE' ||
                                    data.VinExplodeMode.toUpperCase() === 'VINEXPLODELOCAL');

                                defer.resolve(true);
                            },
                            function (err) {
                                $scope.vehicleDefinition.modelYearSetup.clearItems();
                                $scope.signalVehicleError("Could not determine vehicle attributes.");
                                defer.reject(err);
                            });
                return defer.promise;
            }
            $scope.toggleVehicleUsage = function(usage){
                rateQuoteRetrievalCoordService.endQuoteRetrieval();
                $scope.getCurrentVehicleInfo();
                hasVehicleChanged();
            }

            $scope.updateCertification = function(){
                rateQuoteRetrievalCoordService.endQuoteRetrieval();
                $scope.getCurrentVehicleInfo();
                hasVehicleChanged();
            };

            $scope.updateSaleType = function(){
                rateQuoteRetrievalCoordService.endQuoteRetrieval();
                $scope.getCurrentVehicleInfo();
                hasVehicleChanged();
            };

            //starting a new quote
            $scope.$on(quoteCreationEvents.startNewProductQuote, function(event, args) {
                if (rateQuoteCoordService.VehicleData.vehicleType !== $scope.supportedVehicleType)//ignore AUTOs to quit from interfering with other panel
                    return;
                var g = args.newguid;
                if (g && $scope.newGUID === g)//in case multiple events attempting processing
                    return;
                if (g)
                    $scope.newGUID = g;

                $scope.vehicleDefinition.prevVIN = null;
                $scope.initVehicleData();
            });

            $scope.initVehicleData = function(){
                rateQuoteCoordService.clearVehicle();
                quoteInitializationService.initializeVehicleData();
                $scope.vehicleData = rateQuoteCoordService.VehicleData;

                if (!$scope.vehicleData.dateOfSale || $scope.vehicleData.dateOfSale === 'undefined') {
                    $scope.vehicleData.dateOfSale = $scope.initializeDate();
                };

                if ($scope.vehicleData.vin) {
                    $scope.vehicleVINChanged($scope.vehicleData.vin);
                    //firstQuote = false;
                }
                else { $scope.signalVehicleChanged();}

            }

            $scope.$on(quoteCreationEvents.dealDataChanged, function(event, dealData) {
                $scope.vehicleDefinition.dealInfoChanged = true;
            });

            // Parses a date in either mm/dd/yyyy or mm-dd-yyyy format
            function parseMmDdYyyy(date) {
                var splitOn = date.indexOf('/') >= 0 ? '/' : '-';
                var dateSplit = date.split(splitOn);
                return new Date(parseInt(dateSplit[2]),parseInt(dateSplit[0])-1,parseInt(dateSplit[1]));
            }

            //we retrieved an existing quote, so fill in the values for the vehicle
            $scope.$on(quoteCreationEvents.vehicleDataRetrieved, function(event, vehicleArgs) {
                if (rateQuoteCoordService.VehicleData.vehicleType !== $scope.supportedVehicleType)//ignore RVs to quit from interfering with other panel
                    return;
                //vehicleArgs in models/vehicle-info.js
                $scope.vehicleData = rateQuoteCoordService.VehicleData;

                if($scope.vehicleData.vehicleCert) {
                    $scope.vehicleDefinition.vehicleCertSetup.selectedVal = $scope.vehicleData.vehicleCert;
                }
                if($scope.vehicleData.vehicleUsage) {
                    $scope.vehicleDefinition.vehicleUsageSetup.selectedVal = _.isArray($scope.vehicleData.vehicleUsage) ? $scope.vehicleData.vehicleUsage.join(',') : $scope.vehicleData.vehicleUsage;
                }
                if ($scope.vehicleData.newUsed) {
                    if ($scope.vehicleDefinition.vehiclePlanTypeSetup.selectedVal && ($scope.vehicleDefinition.vehiclePlanTypeSetup.selectedVal == 'Yes' || $scope.vehicleDefinition.vehiclePlanTypeSetup.selectedVal == 'No'))
                    {
                        $scope.vehicleDefinition.vehiclePlanTypeSetup.selectedVal = $scope.vehicleData.newUsed == 'New' ? 'Yes' : 'No';
                    }
                    else
                        $scope.vehicleDefinition.vehiclePlanTypeSetup.selectedVal = $scope.vehicleData.newUsed;
                }
                //vin quote or y/m/m??
                if ($scope.vehicleData.vin){
                    //$scope.vehicleData.vin = vehicleArgs.vin;
                    $scope.vehicleVINChanged($scope.vehicleData.vin);
                }else{
                    $scope.selectModelYear($scope.vehicleData.year, true);
                    $scope.selectMake($scope.vehicleData.makeId, true);
                    $scope.selectModel($scope.vehicleData.modelId,true);
                }
            });
            //set date to today
            $scope.initializeDate = function(){
                var today = new Date();
                return today;
            }
            //get model years from service
            $scope.getVehicleModelYears = function(){
                if (rateQuoteCoordService.VehicleData.vehicleType !== $scope.supportedVehicleType)//ignore AUTOs to quit from interfering with other panel
                    return;
                vehicleDefinitionService.getModelYears()
                    .then(
                        function modelYearsReceived(data) {
                            if (data && data.length > 0)
                                $scope.vehicleDefinition.modelYearSetup.listItems = data;
                            else {
                                $scope.vehicleDefinition.modelYearSetup.clearItems();
                            }
                        },
                        function(err) {
                            $scope.vehicleDefinition.modelYearSetup.clearItems();
                            $scope.signalVehicleError("Could not get vehicle model years.");
                        });
            }
            //get makes from service
            $scope.getVehicleMakes = function(){
                if (rateQuoteCoordService.VehicleData.vehicleType !== $scope.supportedVehicleType)//ignore AUTOs to quit from interfering with other panel
                    return;
                $scope.vehicleDefinition.modelSetup.listItems = [];
                vehicleDefinitionService.getMakes()
                    .then(
                        function makesReceived(data) {
                            $scope.vehicleDefinition.makeSetup.listItems = data;
                            if ($scope.vehicleData.makeId)
                                $scope.selectMake($scope.vehicleData.makeId,false,false);
                        },
                        function(err){
                            $scope.vehicleDefinition.makeSetup.clearItems();
                            $scope.signalVehicleError("Could not get vehicle makes.");
                        });
            }
            //get models from service
            $scope.getVehicleModels = function(){
                vehicleDefinitionService.getModels($scope.vehicleDefinition.makeSetup.selectedItem.InternalMakeId,
                    $scope.vehicleDefinition.modelYearSetup.selectedItem.modelYear)
                    .then(
                        function modelReceived(data) {
                            if (!($scope.vehicleData.vin && $scope.vehicleData.vin.length > 0))
                                $scope.vehicleDefinition.modelSetup.listItems = data;
                        },
                        function(err) {
                            $scope.vehicleDefinition.modelSetup.clearItems();
                            $scope.signalVehicleError("Could not get vehicle models.")
                        });
            }
            //get vehicle usages from service
            $scope.getVehicleUsages = function() {
                vehicleDefinitionService.getVehicleUsages()
                .then(
                    function usagesReceived(data) {
                        var usages = data;
                        $scope.vehicleDefinition.vehicleUsageSetup.listItems = (usages && usages.length > 0) ? usages : null;
                        $scope.vehicleDefinition.vehicleUsageSetup.selectedVal = (usages && usages.length > 0) ? usages[0].vehicleUsage : null;
                        $scope.vehicleData.vehicleUsage = (usages && usages.length > 0) ? usages[0].vehicleUsage : null;
                        $scope.vehicleDefinition.usageRequired = false;
                    },
                    function(err) {
                        $scope.vehicleDefinition.vehicleUsageSetup.clearItems();
                        $scope.signalVehicleError("Could not get vehicle usages.")
                    });
            }

            $scope.getVehicleVinUsages = function() {
                vehicleDefinitionService.getVehicleVINUsages()
                .then(
                    function usagesReceived(data) {
                        var usages = data.usages;
                        $scope.vehicleDefinition.vehicleUsageSetup.listItems = (usages && usages.length > 0) ? usages : null;
                        if ($scope.vehicleData.vehicleUsage) {
                            $scope.vehicleDefinition.vehicleUsageSetup.selectedVal = _.isArray($scope.vehicleData.vehicleUsage) ? $scope.vehicleData.vehicleUsage.join(',') : $scope.vehicleData.vehicleUsage;
                        } else {
                            $scope.vehicleDefinition.vehicleUsageSetup.selectedVal = null;
                            $scope.vehicleData.vehicleUsage = null;
                        }
                        $scope.vehicleDefinition.usageRequired = false;
                    },
                    function(err) {
                        $scope.vehicleDefinition.vehicleUsageSetup.clearItems();
                        $scope.signalVehicleError("Could not get vehicle usages.")
                    });
            }            
            //get vehicle cert options from service
            $scope.getVehicleCerts = function() {
                vehicleDefinitionService.getVehicleCertOptions()
                    .then(
                        function certOptionsReceived(data) {
                            $scope.vehicleDefinition.vehicleCertSetup.listItems = (data && data.length > 0) ? data : null;
                            $scope.vehicleDefinition.vehicleCertSetup.selectedVal = (data && data.length > 0) ? data[0].vehicleCertification : null;
                            $scope.vehicleData.vehicleCert = (data && data.length > 0) ? data[0].vehicleCertification : null;
                        },
                        function(err) {
                            $scope.vehicleDefinition.vehicleCertSetup.clearItems();
                            $scope.signalVehicleError("Could not get vehicle certification options.")
                        });
            }
            //get sale type (NEW/USED) from service
            $scope.getVehicleSaleTypes = function() {
                vehicleDefinitionService.getVehicleSaleTypes()
                    .then(
                        function saleTypesReceived(data) {
                            if (data && data.length > 0 && data[0].vehicleSaleType != 'BtBYes') {
                                $scope.vehicleDefinition.vehiclePlanTypeSetup.listItems = (data && data.length > 0) ? data : null;

                                $scope.vehicleDefinition.vehiclePlanTypeSetup.selectedVal = (data && data.length > 0) ? ($scope.vehicleData.newUsed && $scope.vehicleData.newUsed.length > 0)
                                    ? data.filter(function (val) {
                                    return val.vehicleSaleType.charAt(0) == $scope.vehicleData.newUsed
                                })[0].vehicleSaleType
                                    : data[0].vehicleSaleType
                                    : null;

                                $scope.vehicleData.vehicleSaleType = (data && data.length > 0) ? ($scope.vehicleData.newUsed && $scope.vehicleData.newUsed.length > 0)
                                    ? data.filter(function (val) {
                                    return val.vehicleSaleType.charAt(0) == $scope.vehicleData.newUsed
                                })[0].vehicleSaleType
                                    : data[0].vehicleSaleType
                                    : null;
                            }
                            else {
                                $scope.vehicleDefinition.vehiclePlanTypeSetup.listItems = (data && data.length > 0) ? [{'vehicleSaleType': 'Yes'}, {'vehicleSaleType': 'No'}] : null;

                                $scope.vehicleDefinition.vehiclePlanTypeSetup.selectedVal = (data && data.length > 0) ? ($scope.vehicleData.newUsed && $scope.vehicleData.newUsed.length > 0)
                                    ? ($scope.vehicleData.newUsed.toUpperCase() == 'NEW') ? 'Yes' : 'No'
                                    : 'Yes'
                                    : null;

                                $scope.vehicleData.vehicleSaleType = (data && data.length > 0) ? ($scope.vehicleData.newUsed && $scope.vehicleData.newUsed.length > 0)
                                    ? ($scope.vehicleData.newUsed.toUpperCase() == 'NEW') ? 'New' : 'Used'
                                    : 'New'
                                    : null;
                            }
                        },
                        function(err) {
                            $scope.vehicleDefinition.vehiclePlanTypeSetup.clearItems();
                            $scope.signalVehicleError("Could not get vehicle sale types.")
                        });
            }
            //get vehicle data in scope (for events)
            $scope.getCurrentVehicleInfo = function(){
                $scope.vehicleData.makeName = $scope.vehicleDefinition.makeSetup.selectedItem != null ? $scope.vehicleDefinition.makeSetup.selectedItem.MakeName : null;
                $scope.vehicleData.modelName = $scope.vehicleDefinition.modelSetup.selectedItem !=null ? $scope.vehicleDefinition.modelSetup.selectedItem.PartnerModelName : null;
                $scope.vehicleData.vehicleUsage = ($scope.vehicleDefinition.vehicleUsageSetup.selectedVal || '').length == 0 ? [] : $scope.vehicleDefinition.vehicleUsageSetup.selectedVal.split(',');
                $scope.vehicleData.vehicleCert = $scope.vehicleDefinition.vehicleCertSetup.selectedVal;
                $scope.vehicleData.vehicleType = $scope.supportedVehicleType;
                $scope.vehicleData.rvType = null;
                $scope.vehicleData.newUsed =  $scope.vehicleData.vehicleSaleType = $scope.vehicleDefinition.vehiclePlanTypeSetup.selectedVal == 'Yes' ? 'New' : $scope.vehicleDefinition.vehiclePlanTypeSetup.selectedVal == 'No' ? 'Used' : $scope.vehicleDefinition.vehiclePlanTypeSetup.selectedVal ;
                rateQuoteCoordService.VehicleData = $scope.vehicleData;
            }
            //changing something about the vehicle
            $scope.signalVehicleChanged = function(endRetrieve){
                $rootScope.$broadcast(quoteCreationEvents.vehicleDataChanged, { vehicleType : $scope.supportedVehicleType });
                vehicleProductsProcessingService.productData.haveProducts = false;
                //if we're not in the process of setting up an existing quote, remove any quotes
                if (!rateQuoteRetrievalCoordService.inQuoteRetrieval())
                    $rootScope.$broadcast(quoteCreationEvents.removeCurrentQuotes,{});

                var model = $scope.vehicleData.makeId;//if we at least get the make and VIN, we are good
                var modelOK = false;
                if (isNaN(model)) { modelOK = model.length > 0;}
                else { modelOK = (parseInt(model) > 0); }
                if ($scope.vehicleData.dataReadyToRate() && (modelOK || !$scope.vehicleDefinition.vinDecode)) {
                    //the vehicle is ready to quote
                    $scope.signalVehicleDataValid();
                }
                if (endRetrieve)
                    rateQuoteRetrievalCoordService.endQuoteRetrieval();
            }
            //throw an event when vehicle data is valid
            $scope.signalVehicleDataValid = function(){
                rateQuoteCoordService.getNewGuid(rateQuoteRetrievalCoordService.inQuoteRetrieval())
                    .then(function gotNewGuid(guid) {

                        $scope.getCurrentVehicleInfo();

                        rateQuoteCoordService.VehicleData = $scope.vehicleData;

                        //KRE - do not load rates when we have pending required fields
                        var quoteIntegrated = $window.sessionStorage.getItem('SESS_QUOTE_MODE');
                        if (quoteIntegrated && quoteIntegrated === 'MENUPRO_INTEGRATED_QUOTE'){ //are we quote integrated?
                            var quotePrefill = JSON.parse($window.sessionStorage.getItem('SESS_INTEGRATION_PREFILL'));
                            if (quotePrefill
                                && quotePrefill.quoteRequiredFields
                                && angular.isArray(quotePrefill.quoteRequiredFields)
                                && quotePrefill.quoteRequiredFields.length > 0
                                && !($scope.vehicleData.inService) ){
                                return;
                            }
                        }
                            //if we didn't change the DOS from previous, display preferences
                            // should be the same
                        if(!$scope.fabMenu.$invalid) {
                            dealerPreferencesService.getAllProductDisplayPreferences(new Date($scope.vehicleData.dateOfSale))
                            .then(
                                function(){
                                    vehicleDefinitionService.vehicleDetailsData.ready = true;
                                    vehicleProductsProcessingService.clearProducts(true);
                                    vehicleProductsProcessingService.GetEligibleProducts();

                                    if ($scope.vehicleData.dataReadyToSaveQuote()) {
                                        $rootScope.$broadcast(quoteCreationEvents.attemptQuoteSave, {});
                                    }
                                }
                            )
                        }
                    });
            }
            //vehicle data errors processed here
            $scope.signalVehicleError = function(message) {
                throw new TLCError(new Error(message), AppErrorCodes.VehicleController_VehicleInfoError);
            }

            //VIN has changed, decode it if we can
            $scope.vehicleVINChanged = function(vin, endRetrieve, doNotSignalVehicleChange){
                if ($scope.vehicleDefinition.prevVIN && $scope.vehicleDefinition.prevVIN == vin)
                    return;
                hasVehicleChanged();        // track the vehicle changed ...
                $scope.vehicleData.makeId =
                    $scope.vehicleData.modelId = "";
                $scope.vehicleData.year = 0;

                getProviderVehicleMode()
                .then(function gotProviderVehicleMode() {
                    if (vin && $scope.vehicleDefinition.vinDecode) {
                        vehicleDefinitionService.getModelDetails($scope.vehicleData.vin)
                            .then(
                                function modelDetailsReceived(data) {
                                    if (data.Inservice) {
                                        $scope.vehicleData.inService = new Date(data.Inservice);
                                    }
                                    if (typeof(data.Make) != 'undefined' && data.Make.MakeName) {
                                        $scope.vehicleDefinition.makeSetup.listItems = [data.Make];//set the make
                                        $scope.vehicleDefinition.modelSetup.listItems = [data.Model];//set the model
                                        $scope.vehicleDefinition.modelYearSetup.listItems = [{"modelYear": data.Model.ModelYear > 0 ? data.Model.ModelYear : ""}];//set the model year
                                        $scope.selectModelYear(data.Model.ModelYear, false);
                                        $scope.selectMake(data.Make.InternalMakeId, false);
                                        $scope.selectModel(data.Model.InternalModelId, false);
                                    } else if (!$scope.vehicleDefinition.allowYearMakeModelQuoting && $scope.vehicleDefinition.vinDecode) {
                                        $scope.vehicleData.modelId = $scope.vehicleData.vin;
                                    }

                                    if (!doNotSignalVehicleChange || $scope.ignoreDoNotSignalVehicleChange) {
                                        $scope.signalVehicleChanged(endRetrieve);
                                    }
                                },
                                function (err) {
                                    $scope.signalVehicleError("Could not decode vehicle VIN.")
                                });
                    }
                    else if (!$scope.vehicleDefinition.vinDecode) {
                        if (!doNotSignalVehicleChange) {
                            $scope.signalVehicleChanged(endRetrieve);
                        }
                    }
                    else if (!$scope.vehicleData.modelId) {
                        $scope.vehicleDefinition.vehicleModels = [];
                        $scope.getVehicleModelYears();
                        $scope.getVehicleMakes();
                        if (!doNotSignalVehicleChange) {
                            $scope.signalVehicleChanged(endRetrieve);
                        }
                    }
                });
            }
            //selected model year has changed
            $scope.selectModelYear = function(mYear, reload, endRetrieve){
                if (!mYear){
                    return;
                }
                $scope.vehicleDefinition.modelYearSetup.selectedItem = $scope.vehicleDefinition.modelYearSetup.listItems.filter(function(val) { return val.modelYear == mYear })[0];
                $scope.vehicleData.year = mYear;
                if (reload) {
                    if ($scope.vehicleDefinition.makeSetup.selectedItem!= null) { $scope.getVehicleModels(); }
                }
            }
            //selected make has changed
            $scope.selectMake = function(make, reload, endRetrieve){
                if (!make){
                    return;
                }
                $scope.vehicleDefinition.makeSetup.selectedItem = $scope.vehicleDefinition.makeSetup.listItems.filter(function(val) { return val.InternalMakeId == make })[0];
                if (!$scope.vehicleDefinition.makeSetup.selectedItem)
                    $scope.vehicleDefinition.makeSetup.selectedItem = $scope.vehicleDefinition.makeSetup.listItems.filter(function(val) { return val.MakeName.toUpperCase() == make.toUpperCase() })[0];
                $scope.vehicleData.makeId = $scope.vehicleDefinition.makeSetup.selectedItem.InternalMakeId;
                $scope.vehicleData.makeName = $scope.vehicleDefinition.makeSetup.selectedItem.MakeName;
                if (reload) {
                    if ($scope.vehicleDefinition.modelYearSetup.selectedItem!= null) { $scope.getVehicleModels(); }
                }
            }
            //selected model has changed
            $scope.selectModel = function(model, reload, endRetrieve){
                if (!model || model == 'UNKNOWN'){
                    return;
                }
                $scope.vehicleDefinition.modelSetup.selectedItem = $scope.vehicleDefinition.modelSetup.listItems.filter(function(val) { return val.InternalModelId == model })[0];
                $scope.vehicleData.modelId = model;
                $scope.vehicleData.modelName = $scope.vehicleDefinition.modelSetup.selectedItem.PartnerModelName;
            }
            //is VIN data being entered?
            $scope.vinEntered = function(){
                if (!$scope.vehicleData || typeof $scope.vehicleData.vin === "undefined")
                    return false;
                return $scope.vehicleData.vin.length > 0;
            }

            //keeps user from entering anything bigger than 999999
            $scope.odometerEntered = function(){
                if ($scope.vehicleData.odometer && $scope.vehicleData.odometer.toString().length >8)
                    $scope.vehicleData.odometer = parseInt($scope.vehicleData.odometer.toString().slice(0,8));
            }
            //init the settings
            quoteInitializationService.initializeVehicleData();
            $scope.initializeDetails();

            // Determines if the Vehicle information has changed.
            function hasVehicleChanged() {
                var vehInfoChanged = false;
                var curUsage;
                var lastUsage;
                if (angular.isArray($scope.vehicleData.vehicleUsage)) {
                    curUsage = ($scope.vehicleDefinition.vehicleUsageSetup.selectedVal || '').toUpperCase();
                    lastUsage = ($scope.vehicleDefinition.prevUsage || []).join(',').toUpperCase();
                } else {
                    curUsage = ($scope.vehicleDefinition.vehicleUsageSetup.selectedVal || '').toUpperCase();
                    lastUsage = ($scope.vehicleDefinition.prevUsage || '').toString().toUpperCase();
                }
                if ($scope.vehicleData.vin != $scope.vehicleDefinition.prevVIN ||
                    $scope.vehicleData.year != $scope.vehicleDefinition.prevyear ||
                    $scope.vehicleData.makeId != $scope.vehicleDefinition.prevmakeId ||
                    $scope.vehicleData.modelId != $scope.vehicleDefinition.prevmodelId ||
                    $scope.vehicleData.odometer != $scope.vehicleDefinition.prevOdometer ||
                    $scope.vehicleData.dateOfSale != $scope.vehicleDefinition.prevDateOfSale ||
                    $scope.vehicleData.inService != $scope.vehicleDefinition.prevInService ||
                    $scope.vehicleData.vehicleCert != $scope.vehicleDefinition.prevCert ||
                    curUsage != lastUsage
                    //$scope.vehicleDefinition.dealInfoChanged
                ) {
                    vehInfoChanged = true;
                    vehicleProductsProcessingService.setVehicleInfoDataChanged(vehInfoChanged);
                    $window.sessionStorage.setItem('SESS_VEHICLE_CHANGED', JSON.stringify(vehInfoChanged));
                    return true;
                }
                vehicleProductsProcessingService.setVehicleInfoDataChanged(vehInfoChanged);
                $window.sessionStorage.setItem('SESS_VEHICLE_CHANGED', JSON.stringify(vehInfoChanged));
                return false;
            }

            $scope.$on(tuxFabMenuEvents.closed, function () {
                if ($scope.vehicleData.vehicleType !== $scope.supportedVehicleType)
                    return;//don't care if not an RV
                var vehicleChanged = hasVehicleChanged();
                //$scope.vehicleDefinition.dealInfoChanged = false;//reset when we close the FAB menu
                $window.sessionStorage.setItem('SESS_VEHICLE_CHANGED', JSON.stringify(vehicleChanged));
                $scope.ignoreDoNotSignalVehicleChange = true;
            });

            $scope.$on(quoteCreationEvents.vechicleDataChangedProceed, function(event, signal){
                if ($scope.vehicleData.vehicleType !== $scope.supportedVehicleType|| $window.sessionStorage.getItem('SESS_VEHICLE_CHANGED')==null) {
                    if (!vehicleProductsProcessingService.getFilteringProductsChanged()) return;//don't care if not an RV
                }
                //clearing the items in storage for future use
                $window.sessionStorage.removeItem('SESS_VEHICLE_CHANGED');
                if (signal)
                    $scope.signalVehicleChanged(true);
            });

            // Saves initial Vehicle definition values.
            $scope.$on(tuxFabMenuEvents.shown, function (evt, arg) {
                $scope.checkVehicleChangeAuto(arg);
                $scope.vehicleDefinition.dealInfoChanged = false;//reset when we close the FAB menu
                $scope.capturePreviousValues();
                $scope.ignoreDoNotSignalVehicleChange = false;
            });

            $scope.$on(tuxFabMenuEvents.changeVehicle, function (evt, arg) {
                $scope.checkVehicleChangeAuto(arg);
            });

            $scope.checkVehicleChangeAuto = function(fabGroup){
                if (fabGroup === 1 && $scope.vehicleData.vehicleType !== $scope.supportedVehicleType){
                    $scope.vehicleData.vehicleType = $scope.supportedVehicleType;
                    $scope.vehicleData.clearVehicle();
                }else if (fabGroup === 0) {$scope.vehicleData.vehicleType = null; }
            }

            function getMin(days)
            {
                vehicleDos = $scope.today;
                $scope.minDate = new Date(
                    vehicleDos.getFullYear(),
                    vehicleDos.getMonth(),
                    vehicleDos.getDate() - days);
            }

           function getMaxFuture(days)
            {
                return new Date(vehicleDos.getFullYear(),vehicleDos.getMonth(),vehicleDos.getDate() + days);

            }

            function getProviderDateOfSaleSettings()
            {
                /*Past days 0 is calendar has no restrictions on selection of past days */
                /*Futrue days 0 = calendar can not select future days, if -1 then no retriction on futrue date*/
                vehicleDos = $scope.today;
                var dateSettings =[];
                dateSettings = JSON.parse(imSessionVarsService.getCurrentProviderSettings('UI-DateOfSale'));

                var pastDays  = _.filter(dateSettings, function(n) { return n.Key == "PastDays" })
                var futureDays = _.filter(dateSettings, function(o) { return o.Key == "FutureDays" })
                if (pastDays.length > 0)
                {
                    if (pastDays[0].Value > 0) {
                        getMin(pastDays[0].Value)
                    }
                }
                if (futureDays.length > 0) {
                    if (futureDays[0].Value > -1) {
                        $scope.maxDate = getMaxFuture(futureDays[0].Value);
                    }
                }
            }

            function getProviderInServiceDateSettings()
            {
                /*Past days 0 is calendar has no restrictions on selection of past days */
                /*Future days 0 = calendar can not select future days, if -1 then no retriction on futrue date*/
                vehicleDos = $scope.today;
                var dateSettings =[];
                dateSettings = JSON.parse(imSessionVarsService.getCurrentProviderSettings('UI-InsrvDate'));

                var futureDays = _.filter(dateSettings, function(o) { return o.Key == "FutureDays" })
                if (futureDays.length > 0) {
                    if (futureDays[0].Value > -1) {
                        $scope.today = getMaxFuture(futureDays[0].Value)
                    }
                    else {
                        //no restriction on future date
                        $scope.today = "";
                    }
                }
            }

            $scope.CheckDateValidity = function()
            {
                if($scope.fabMenu.inDateOfSale.$error.valid)
                {
                    return "Invalid format date";
                }
                return "Invalid sale date";

            }

            $scope.capturePreviousValues = function(){
                $scope.vehicleDefinition.prevVIN = $scope.vehicleData.vin;
                $scope.vehicleDefinition.prevOdometer = $scope.vehicleData.odometer;
                $scope.vehicleDefinition.prevDateOfSale = $scope.vehicleData.dateOfSale;
                $scope.vehicleDefinition.prevInService = $scope.vehicleData.inService;
                $scope.vehicleDefinition.prevyear = $scope.vehicleData.year;
                $scope.vehicleDefinition.prevmakeId = $scope.vehicleData.makeId;
                $scope.vehicleDefinition.prevmodelId = $scope.vehicleData.modelId;
                $scope.vehicleDefinition.prevCert = $scope.vehicleData.vehicleCert || $scope.vehicleDefinition.vehicleCertSetup.selectedVal;
                $scope.vehicleDefinition.prevUsage = _.clone($scope.vehicleData.vehicleUsage);
            };

            $scope.showVerifyEligibilityLink = function() {
                return !!($scope.verifyEligibilityUrl);
            };

            $scope.openVerifyEligibilityUrl = function() {
                var financingWindow = $window.open(
                    $scope.verifyEligibilityUrl, "ESP Ineligible Listings",
                    "height=800px,width=1024px,status=0,toolbar=0,menubar=0,resizable=1,location=0,scrollbars=1,dependent=1"
                );
            };

            $scope.odometerBlur = function() {
                hasVehicleChanged();
            };

            $scope.toggleVehicleUsageChecked = function(code) {
                var current = $scope.vehicleDefinition.vehicleUsageSetup.selectedVal || '';
                if (current.indexOf(code) > -1) { current = current.replace(code + ',', '').replace(code, ''); }
                else { current = (current || '').length > 0 ? current + ',' + code : code; }
                $scope.vehicleDefinition.vehicleUsageSetup.selectedVal = current;
                hasVehicleChanged();
            }
        }]);
